//
//
//
//
//
//
//
//
export default {
  name: 'MdmProgressBar',
  props: {
    progress: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: ''
    }
  }
};